import { render, staticRenderFns } from "./BookC.vue?vue&type=template&id=cadbaeae&"
import script from "./BookC.vue?vue&type=script&lang=js&"
export * from "./BookC.vue?vue&type=script&lang=js&"
import style0 from "./BookC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports